import { render } from "./FooterDesktop.vue?vue&type=template&id=d3f7e61a&scoped=true"
import script from "./FooterDesktop.vue?vue&type=script&lang=js"
export * from "./FooterDesktop.vue?vue&type=script&lang=js"

import "./FooterDesktop.vue?vue&type=style&index=0&id=d3f7e61a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f7e61a"]])

export default __exports__